export const API_BASE_URL = "https://api.hjlus.iosx.in/api/v1/";
